export default ".star_empty {\n    fill: none!important;\n}\n\n.emoji_empty {\n    background-color: transparent;\n}\n";